import { render, staticRenderFns } from "./BulletPointReadMore.vue?vue&type=template&id=910f9488&"
import script from "./BulletPointReadMore.vue?vue&type=script&lang=js&"
export * from "./BulletPointReadMore.vue?vue&type=script&lang=js&"
import style0 from "./BulletPointReadMore.vue?vue&type=style&index=0&id=910f9488&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports